import { Button } from "@volca/ui/components/ui/button";
import { toast } from "@volca/ui/lib/toast";
import { getErrorMessage } from "@/core/api/errors";
import { usePayPeriodNoteAction } from "./query";
import type { NoteAction, PayrollPeriodNote } from "./types";

export const PayrollNoteActions = ({
  businessId,
  periodStart,
  note,
  canForward = false,
}: {
  businessId: string | null;
  periodStart: string;
  note: Pick<PayrollPeriodNote, "id" | "status">;
  canForward?: boolean;
}) => {
  const action = usePayPeriodNoteAction(businessId, periodStart);
  const resolve = (type: Exclude<NoteAction["action"], "create">) =>
    action.mutate(
      { action: type, id: note.id },
      {
        onError: (error) =>
          toast.error("Note not updated", {
            description: getErrorMessage(error),
          }),
      },
    );

  if (note.status === "addressed") {
    return (
      <Button
        size="xs"
        variant="outline"
        disabled={action.isPending}
        onClick={() => resolve("reopen")}
      >
        Reopen
      </Button>
    );
  }

  return (
    <>
      <Button
        size="xs"
        variant="default"
        disabled={action.isPending}
        onClick={() => resolve("address")}
      >
        Addressed
      </Button>
      <Button
        size="xs"
        variant="outline"
        disabled={action.isPending || !canForward}
        onClick={() => resolve("forward")}
      >
        Send to next open period
      </Button>
    </>
  );
};
